import { Message, MessageTime } from '~/DesignSystem/components/messages'

type MessageProps = React.ComponentProps<typeof Message>

type OutgoingMessageProps = {
  time?: number
} & Omit<MessageProps, 'direction' | 'variant'> & {
    direction?: MessageProps['direction']
    variant?: MessageProps['variant']
  }

function OutgoingMessage({
  time,
  children,
  direction = 'outgoing',
  variant = 'outline',
  ...props
}: OutgoingMessageProps) {
  return (
    <Message direction={direction} variant={variant} {...props}>
      {children}
      {!!time && <MessageTime>{time}</MessageTime>}
    </Message>
  )
}

export { OutgoingMessage }
